(function () {
  if (window.__idealProductDetailsDrawerExternalInit) return;
  window.__idealProductDetailsDrawerExternalInit = true;

  var CLOSE_MS = 700;

  function enhanceSpecTables(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-ideal-spec-table] p, [data-ideal-spec-table] li').forEach(function(row) {
      if (row.dataset.specEnhanced === 'true' || row.querySelector('.ideal-product-specs__label')) return;

      var text = row.textContent.trim();
      var separatorIndex = text.indexOf(':');
      if (separatorIndex < 1) separatorIndex = text.indexOf(' - ');
      if (separatorIndex < 1) return;

      var label = text.slice(0, separatorIndex).trim();
      var value = text.slice(separatorIndex + (text.charAt(separatorIndex) === ':' ? 1 : 3)).trim();
      if (!label || !value) return;

      row.textContent = '';

      var labelEl = document.createElement('span');
      labelEl.className = 'ideal-product-specs__label';
      labelEl.textContent = label;

      var valueEl = document.createElement('span');
      valueEl.className = 'ideal-product-specs__value';
      valueEl.textContent = value;

      row.append(labelEl, valueEl);
      row.dataset.specEnhanced = 'true';
    });
  }

  window.openProductDrawer = function (id) {
    var overlay = document.getElementById(id);
    if (!overlay || overlay.classList.contains('pd-is-open')) return;

    document.body.style.overflow = 'hidden';
    overlay.classList.remove('pd-is-closing');
    enhanceSpecTables(overlay);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('pd-is-open');
      });
    });
  };

  window.closeProductDrawer = function (id) {
    var overlay = document.getElementById(id);
    if (!overlay || !overlay.classList.contains('pd-is-open')) return;

    overlay.classList.remove('pd-is-open');
    overlay.classList.add('pd-is-closing');

    setTimeout(function () {
      overlay.classList.remove('pd-is-closing');
      document.body.style.overflow = '';
    }, CLOSE_MS);
  };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-product-details-drawer-open]');
    if (opener) {
      event.preventDefault();
      window.openProductDrawer(opener.getAttribute('aria-controls'));
      return;
    }

    if (event.target && event.target.classList.contains('pd-overlay')) {
      window.closeProductDrawer(event.target.id);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('.pd-overlay.pd-is-open');
    if (open) window.closeProductDrawer(open.id);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { enhanceSpecTables(document); }, { once: true });
  } else {
    enhanceSpecTables(document);
  }
})();
